var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateHeader',{attrs:{"header":'Riwayat Penjualan Emas',"withBackButton":true,"to":'/dashboard'}},[_c('TableSold',{attrs:{"API":'/sold-product',"goldData":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }